import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { api_url } from '../../Constants/web_services';
import { selectSignedIn, selectUserData } from '../../Redux/UserSlice';
import img1 from "../../Assets/images/1.png";
import img2 from "../../Assets/images/2.png";
import img3 from "../../Assets/images/3.png";

const ContactScreen = () => {
    const userData = useSelector(selectUserData);
    const isSignedIn = useSelector(selectSignedIn);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');

    const handleSubmit = async (e) => {

        e.preventDefault();

        // if (!name || !email || !contact || !message || !subject) {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error',
        //         text: 'Please fill in all the required fields.',
        //     });
        //     return; // Stop form submission if any field is empty
        // }
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: isSignedIn ? userData.username : name,
                email: isSignedIn ? userData.email : email,
                contact: isSignedIn ? userData.contact : contact,
                subject,
                message,
                user_id: isSignedIn ? userData.id : null,
            }),
        };

        try {
            const response = await fetch(`${api_url}/api/contact-us`, requestOptions);
            if (response.ok) {
                setName('');
                setEmail('');
                setContact('');
                setMessage('');
                setSubject('');
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Your offer has been successfully submitted.',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to submit your offer. Please try again later.'
                });
            }
        } catch (error) {
            console.error("API request error:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while processing your request. Please try again later.'
            });
        }
    };

    return (
        <div className="aon-contact-area">
            <div className="container">
                <div className="section-head text-center">
                    <h2 className="sf-title">Contact Information</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do usmod
                        tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                </div>
                <div className="section-content">
                    <div className="sf-contact-info-wrap">
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img1} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Mailing Address</h4>
                                        <p>121 King Street, Melbourne Victoria 3000 Australia</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img2} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Email Info</h4>
                                        <p>info@brandcoin.com</p>
                                        <p>support@brandcoin.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img3} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Phone Number</h4>
                                        <p>0800-123456 (24/7 Support Line)</p>
                                        <p>0800-123654</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sf-contact-form-wrap">
                        <div className="sf-contact-form">
                            <div className="sf-con-form-title text-center">
                                <h2 className="m-b30">Contact Information</h2>
                            </div>
                            <form className="contact-form">
                                <div className="row">
                                    <div className="row justify-content-center">
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label htmlFor="" className='text-022279 text-capitalize fw-600  ml-2'>Name :</label>
                                                <input
                                                    required
                                                    type="text"
                                                    name="name"
                                                    placeholder="Name"
                                                    className={`form-control ${!(userData?.username || name) ? 'border-danger' : 'border-success'}`}
                                                    value={userData?.username || name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label htmlFor="" className='text-center text-022279 text-capitalize fw-600 ml-2' >Email :</label>
                                                <input
                                                    required
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    className={`form-control ${!(userData?.email || email) ? 'border-danger' : 'border-success'}`}
                                                    value={userData?.email || email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label htmlFor="" className='text-center text-022279 text-capitalize fw-600 ml-2' >Phone :</label>
                                                <input
                                                    required
                                                    type="tel"
                                                    name="contact"
                                                    placeholder="Phone"
                                                    className={`form-control ${!(userData?.contact || contact) ? 'border-danger' : 'border-success'}`}
                                                    value={userData?.contact || contact}
                                                    onChange={(e) => setContact(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label htmlFor="" className='text-center text-022279 text-capitalize fw-600 ml-2' >Subject :</label>
                                                <input
                                                    required
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    className={`form-control ${!subject ? 'border-danger' : 'border-success'}`}
                                                    value={subject}
                                                    onChange={(e) => setSubject(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        {/* COLUMNS 5 */}
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label htmlFor="" className='text-center text-022279 text-capitalize fw-600 ml-2' >Message :</label>
                                                <textarea
                                                    required
                                                    name="message"
                                                    placeholder="Message"
                                                    className={`form-control ${!message ? 'border-danger' : 'border-success'}`}
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="col-md-12">
                                                <div
                                                    className="g-recaptcha"
                                                    data-sitekey="6LfcCr0eAAAAAN2P-3cJJC1StgxbUWvwELbMVjnp"
                                                />
                                            </div> */}
                                    </div>

                                </div>
                                <div className="sf-contact-submit-btn ">
                                    <button className="site-button col-md-10" type='submit' disabled={!name || !email || !contact || !subject || !message} onClick={handleSubmit}>
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        {/*Contact Information End*/}
                    </div>
                </div>
            </div>
        </div>




    )
}

export default ContactScreen